module.exports = __webpack_public_path__ + "img/enroll.ad1def4b.svg";